import React from "react";
import { useGetStudentsForTeacher } from "../../hooks/teacherHooks/teacher.hooks";
import { useLocation } from "react-router-dom";
import { ItemDetailCard } from "../card/ItemDetailCard";
import { getValue } from "../../utils/object.utils";
import { Card } from "../card";
import { formatDateBasedOnTimezone } from "../../utils/date.utils";
import { TEXTUAL_DATE_FORMAT } from "../../Constants/date";

export const TeachersStudents = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const teacherId = searchParams.get("teacherId") || "";
  const parsedTeacherId = parseInt(teacherId, 10);

  const { isLoading: isStudentsLoading, data: students } =
    useGetStudentsForTeacher(parsedTeacherId);

  if (isStudentsLoading) return <div />;

  return (
    <div>
      <Card showCard={false}>
        <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-6">
          {students.map((data: any) => {
            const transformedData = [
              {
                key: "Name",
                value: getValue(data, "full_name", ""),
              },
              {
                key: "Class",
                value: getValue(data, "class", ""),
              },
              {
                key: "Roll no",
                value: getValue(data, "roll_no", ""),
              },
              {
                key: "DOB",
                value: formatDateBasedOnTimezone({
                  date: getValue(data, "date_of_birth", ""),
                  formatType: TEXTUAL_DATE_FORMAT,
                }),
              },
            ];
            return <ItemDetailCard data={transformedData} avatar="" />;
          })}
        </div>
      </Card>
    </div>
  );
};
